import * as React from 'react';
import { useContext, createContext } from 'react';
import {  Box, Fade, useMediaQuery, useTheme } from '@mui/material';
import TextContainer from '../Texts/TextContainer';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/styles';
import { ModalTopic } from '../Texts/styles';
interface ModalContent {
    title: string;
    body: React.ReactNode;
}

interface ModalContextProps {
    show: boolean;
    setShow: (show: boolean) => void;
    content: ModalContent;
    setContent: (content: ModalContent) => void;
}

const Container = styled(Box)({
    position: "absolute",
    top: "45%",
    left: "50%",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    transform: "translate(-50%, -50%) scale(0.8)",
    borderRadius: "15px",
    alignItems: "center",
    transition: "all 0.3s ease-in-out",
    maxWidth: "70%",
    minWidth: "50%",
    width: "fit-content",
    minHeight: "35vh",
    height: "fit-content",
    maxHeight: "90vh",
    padding: "1rem 0",
})

const Header = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    maxHeight: "10vh",
    minHeight: "10vh",
    marginBottom: "16px",
    padding: "0rem 1rem 1rem 1rem",
    borderRadius: "15px 15px 0 0",
})

const Content = styled(Box)({
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    overflow: "auto",
    alignItems: "center",
    minHeight: "25vh",
    width: "100%",
    height: "100%",
    padding: "1% 4%",
})

const modalContext = createContext<ModalContextProps>({
    show: false,
    setShow: () => { },
    content: { title: '', body: "" },
    setContent: () => { },
});

export function useModal() {
    const value = useContext(modalContext);
    if (!value)
        throw new Error('useModal must be wrapped inside ModalProvider');
    return value;
}


export default function ModalProvider({ children }: React.PropsWithChildren) {
    const [show, setShow] = React.useState<boolean>(false); // Removed space and angle brackets
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.up('sm'));
    const [content, setContent] = React.useState<ModalContent>({
        title: "Abstract Modal",
        body: null,
    });
    return (
        <modalContext.Provider value={{ show, setShow, content, setContent }}>
            {children}

            {isMobile ?
                <Modal
                    disableEnforceFocus
                    open={show}
                    onClose={() => setShow(false)}
                    closeAfterTransition
                    sx={{
                        "& .MuiBackdrop-root": {
                            backdropFilter: "blur(5px)"
                        }
                    }}

                    aria-labelledby="parent-modal-title"
                    aria-describedby="parent-modal-description"
                >
                    <Fade in={show}>
                        <Container bgcolor="primary.light">
                            <Header>
                                <TextContainer {...ModalTopic}>{content.title}</TextContainer>
                            </Header>
                            <Content>
                                {content.body}
                            </Content>
                        </Container>
                    </Fade>
                </Modal>
                :
                ''
            }
        </modalContext.Provider>
    );
};

